// extracted by mini-css-extract-plugin
module.exports = {"header":"l2ONU","logo":"Ucnxa","container":"y1grW","option":"szN1G","item":"hjaC4","name":"Ugdfu","desc":"AwAT8","price":"l39Ln"};